import { usePresenter } from "./context";
import type { ReferencesBlock } from "./model";
import { safeHref } from "../lib/links";
import { hostOf, referenceMeta } from "./model";

export function ReferencesSlide({ block }: { block: ReferencesBlock }) {
  const { model, live } = usePresenter();
  const refs = block.referenceIds
    ? block.referenceIds.flatMap((id) => model.refs.get(id) ?? [])
    : model.deck.references;
  return (
    <div className="slide refs-slide" data-dense={refs.length > 5}>
      <div className="refs-head">
        <h2 className="refs-h">{block.title}</h2>
        {live && !live.ended && <span className="refs-note">These links are on your phone too.</span>}
      </div>
      <div>
        {refs.map((r) => (
          <div key={r.id} className="ref-row">
            <span className="ref-num">[{model.refNumber.get(r.id)}]</span>
            <span className="ref-main">
              <a className="ref-title" href={safeHref(r.url)} target="_blank" rel="noopener noreferrer">
                {r.title}
              </a>
              <span className="ref-meta">{referenceMeta(r)}</span>
            </span>
            <span className="ref-host">{hostOf(r.url)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
